import api from "../utils/interceptor";
const API_URL = process.env.REACT_APP_API_URL;

// Define custom headers
const customHeaders = {
  "Content-Type": "application/json",
};

// Fetch all product
export const getProductsService = async (data) => {
  try {
    const isHome = data?.is_home;
    let url = API_URL + "products";
    if (isHome) url += "?is_home=" + isHome;
    const response = await api.get(url, { headers: customHeaders });
    return response;
  } catch (error) {
    console.error("Error fetching product:", error);
    throw error;
  }
};

export const getProductDetailService = async (data) => {
  try {
    const response = await api.post(API_URL + "product_details", data, {
      headers: customHeaders,
    });
    return response;
  } catch (error) {
    console.error("Error fetching product:", error);
    throw error;
  }
};

export const getRopService = async (data) => {
  try {
    const response = await api.post(API_URL + "static-rop", data, {
      headers: customHeaders,
    });
    return response;
  } catch (error) {
    console.error("Error fetching product:", error);
    throw error;
  }
};

export const getQuoteService = async (data) => {
  try {
    const response = await api.post(API_URL + "get-quote", data);
    return response;
  } catch (error) {
    console.error("Error fetching product:", error);
    throw error;
  }
};

export const getPolicyService = async (data) => {
  try {
    const response = await api.post(API_URL + "get-policy", data);
    return response;
  } catch (error) {
    console.error("Error fetching product:", error);
    throw error;
  }
};

export const getCountryDetailService = async (id) => {
  try {
    const response = await api.get(API_URL + "country/" + id);
    return response;
  } catch (error) {
    console.error("Error fetching product:", error);
    throw error;
  }
};

export const getTravelProductTypeService = async (id) => {
  try {
    const response = await api.get(API_URL + "get-user-options/" + id, {
      headers: customHeaders,
    });
    return response;
  } catch (error) {
    console.error("Error fetching product:", error);
    throw error;
  }
};

export const getAoMasterDataService = async (data) => {
  try {
    const response = await api.post(
      API_URL + "get-ao-insurance-master-data",
      data,
      { headers: customHeaders }
    );
    return response;
  } catch (error) {
    console.error("Error fetching product:", error);
    throw error;
  }
};

export const getTakafulMasterDataService = async (id) => {
  try {
    const response = await api.get(API_URL + "get-takaful-master-data/" + id, {
      headers: customHeaders,
    });
    return response;
  } catch (error) {
    console.error("Error fetching product:", error);
    throw error;
  }
};

export const getLicenseVehicleService = async (data) => {
  // // console.log(data,'data')
  try {
    const response = await api.post(API_URL + "get-license-vehicle", data, {
      headers: customHeaders,
    });
    return response;
  } catch (error) {
    console.error("Error fetching product:", error);
    throw error;
  }
};

export const getPlateTypeDetailsService = async (id) => {
  try {
    const response = await api.get(API_URL + "get-plate-type-details/" + id, {
      headers: customHeaders,
    });
    return response;
  } catch (error) {
    console.error("Error fetching product:", error);
    throw error;
  }
};

export const getGigVehicaleValuationService = async (data) => {
  try {
    const response = await api.post(
      API_URL + "get-gig-vehicle-valuation",
      data,
      { headers: customHeaders }
    );
    return response;
  } catch (error) {
    console.error("Error fetching product:", error);
    throw error;
  }
};

export const updateTakafulPremiumService = async (data) => {
  try {
    const response = await api.post(API_URL + "update-takaful-premium-value", data, { headers: customHeaders });
    return response;
  } catch (error) {
    console.error("Error fetching product:", error);
    throw error;
  }
};


export const sendVehilcInfoGigService = async (data) => {
  try {
    const response = await api.post(API_URL + "send-gig", data);
    return response;
  } catch (error) {
    console.error("Error fetching product:", error);
    throw error;
  }
};


export const createTransactionDataUser = async (data) => {
  try {
    const response = await api.post(API_URL + "create-transaction", data);
    return response;
  } catch (error) {
    console.error("Error fetching product:", error);
    throw error;
  }
};


export const updateTransactionDataUser = async (data) => {
  try {
    if (localStorage.getItem('transactionId')) {
      const response = await api.put(API_URL + `update-transaction/${localStorage.getItem('transactionId')}`, data);
      return response;
    }
  } catch (error) {
    console.error("Error fetching product:", error);
    throw error;
  }
};


export const sendPdfMail = (payload) => async (dispatch) => {
  try {
    dispatch({ type: "SEND_PDF_MAIL_REQUEST" });
    const response = await api.post(API_URL + `send-pdf-mail`, payload);
    dispatch({
      type: "SEND_PDF_MAIL_SUCCESS",
      payload: response.data,
    });
  } catch (error) {
    dispatch({
      type: "SEND_PDF_MAIL_FAILURE",
      payload: error.message,
    });
  }
};